module.exports = __webpack_public_path__ + "img/UTK.c55a0693.svg";